import { z } from "zod";
import { authorizationSchema } from "./Authorization";

export const userCustomClaimSchema = z.object({
  orgs: z.record(z.string().min(1), authorizationSchema),
});

export type UserCustomClaim = z.infer<typeof userCustomClaimSchema>;
